import Button from "@mui/material/Button";
import { MenuItem, Paper, Select, Typography } from "@mui/material";
import { SOLVER_OPTIONS } from "fe-common/featureFlags/getFeatureFlags";
import React, { useMemo, useState } from "react";
import styled from "@mui/material/styles/styled";
import { FeatureFlagsGroup } from "./FeatureFlagsGroup";

const SettingsBlock = styled("div")({ width: "100%" });

interface SolverFeatureSettingsProps {
  features: Record<string, any>;
  defaults: Record<string, any>;
  handleFeaturesChange: (type: "checked" | "value") => (e) => any;
}

export function SolverFeatureFlagsGroup({
  features,
  defaults,
  handleFeaturesChange,
}: SolverFeatureSettingsProps) {
  const [selectedFlagsGroup, setSelectedFlagsGroup] = useState<string>(
    SOLVER_OPTIONS[0],
  );

  const keys = useMemo(() => {
    const solverFeatures = Object.entries(features)
      .filter(([f]) => f.includes(selectedFlagsGroup))
      // .sort(([f, v]) => (v == defaults[f] ? 1 : -1))
      .map(([f]) => f);
    return solverFeatures;
  }, [defaults, features, selectedFlagsGroup]);

  return (
    <SettingsBlock>
      <Select
        labelId="flags-select-label"
        id="flags-select"
        value={selectedFlagsGroup}
        onChange={(e) => setSelectedFlagsGroup(e.target.value as any)}
      >
        {SOLVER_OPTIONS.map((so) => (
          <MenuItem value={so} key={so}>
            {so}
          </MenuItem>
        ))}
      </Select>
      <FeatureFlagsGroup
        keys={keys}
        prefix={`${selectedFlagsGroup}_`}
        features={features}
        defaults={defaults}
        handleFeaturesChange={handleFeaturesChange}
      />
    </SettingsBlock>
  );
}
